if (!customElements.get('page-navigation')) {
  class PageNavigation extends HTMLElement {
    constructor() {
      super();

      this.elLinks = this.querySelectorAll('a');
      this.elSections = [...this.elLinks].map(el => document.getElementById(el.href.split('#')[1])).filter(el => !!el);

      this.scrollY = 0;
      this.ticking = false;
      this.margin = '0px 0px 0px 0px';

      this.direction = this.getAttribute('direction') || 'horizontal';

      this.initScroll();
      this.setMargin();
      this.elLinks.forEach(el => el.addEventListener('click', this.jumpToSection.bind(this)));
    }

    initScroll() {
      const scrollMethod = () => {
        this.scrollY = window.scrollY;
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.observeSections();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }

      document.removeEventListener('scroll', scrollMethod);
      document.addEventListener("scroll", scrollMethod);
    }

    setMargin() {
      if (this.direction == 'vertical') {
        const { top, height } = this.querySelector('ul').getBoundingClientRect();
        const bottomPosition = window.innerHeight + (top + height);
        this.margin = `${top}px 0px ${bottomPosition}px 0px`;
        console.log(this.margin);
      }
    }

    observeSections() {
      const observer = new IntersectionObserver(entries => {
        const mostVisible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (mostVisible) {
          const elActiveLink = [...this.elLinks].find(el => el.href.split('#')[1] === mostVisible.target.id);
          this.elLinks.forEach(el => el.classList.toggle('active', el == elActiveLink));
        }
      }, {
        threshold: [0, 0.25, 0.5, 0.75, 1],
        rootMargin: this.margin
      });

      this.elSections.forEach(elSection => observer.observe(elSection));
    }

    jumpToSection(ev) {
      ev.preventDefault();
      const sectionId = ev.currentTarget.href.split('#')[1];
      const elSection = document.getElementById(sectionId);
      if (!elSection) return;

      const navHeight = this.direction == 'horizontal' ? this.offsetHeight : 0;
      const headerHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const headerHeight = parseFloat(headerHeightValue) * rootFontSize;

      let top = elSection.offsetTop - headerHeight - navHeight;

      this.classList.add('scrolling');

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      this.checkIfScrollToIsFinished(top);
    }

    checkIfScrollToIsFinished(top) {
      const checkForFinish = setInterval(() => {
        if (Math.round(top) == Math.round(this.scrollY)) {
          this.classList.remove('scrolling');
          clearInterval(checkForFinish);
        }
      }, 25);
    }
  }

  customElements.define('page-navigation', PageNavigation);
}